"use client";

import {
  Home,
  BookOpen,
  MessageCircle,
  Headphones,
  Calendar,
  Search,
  Tv,
  Plus,
  ShoppingBag,
  Book,
} from "lucide-react";
import { Link } from "react-router-dom";

export default function MobileMenu() {
  const pathname = new URL(window.location.href).pathname;

  const menuItems = [
    // { href: "/exchange-comments", icon: MessageCircle, label: "تبادل نظر" },
    // { href: "/workshops", icon: Calendar, label: "کارگاه‌ها" },
    { href: "/", icon: Home, label: "خانه" },
    // { href: "/daily-tips", icon: BookOpen, label: "نکات روزانه" },
    // { href: "/contact-us", icon: Headphones, label: "تماس با ما" },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-30 font-vazir">
      <div className="grid grid-cols-5 py-2 justify-center text-center font-semibold">
        <div className="flex justify-center w-full">
          <Link
            to="/wiki"
            className={`menu-item ${
              location.pathname === "/wiki" ? "text-primary" : ""
            }`}
          >
            <Book className="h-5 w-5" />{" "}
            <span className="text-[10px]">روستآباد</span>
          </Link>
        </div>
        <div className="flex justify-center w-full">
          <Link
            to="/explore"
            className={`menu-item ${
              location.pathname === "/explore" ? "text-primary" : ""
            }`}
          >
            <Search className="h-5 w-5" />
            <span className="text-[10px]">روستا نما</span>
          </Link>
        </div>
        <div className="flex justify-center w-full">
          <Link to="/" className="menu-item">
            <div
              className={`bg-primary rounded-full p-2 -mt-5 border-4 border-white ${
                location.pathname === "/" ? "ring-2 ring-green-400" : ""
              }`}
            >
              <Home className="h-5 w-5 text-white" />
            </div>
            <span className="text-[10px] mt-1">خانه </span>
          </Link>
        </div>
        <div className="flex justify-center w-full">
          <Link
            to="/create"
            className={`menu-item ${
              location.pathname === "/create" ? "text-primary" : ""
            }`}
          >
            <Plus className="h-5 w-5" />
            <span className="text-[10px]">ایجاد</span>
          </Link>
        </div>
        <div className="flex justify-center w-full">
          <Link
            to="/shop"
            className={`menu-item ${
              location.pathname === "/shop" ? "text-primary" : ""
            }`}
          >
            <ShoppingBag className="h-5 w-5" />
            <span className="text-[10px]">بازارچه</span>
          </Link>
        </div>
      </div>
    </div>
  );
}
